// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var SearchExpressionsHelper_1 = require("./SearchExpressionsHelper");
var FilterExpressionHelper_1 = require("./FilterExpressionHelper");
var ExpressionHelperUtilities_1 = require("./ExpressionHelperUtilities");
var ExpressionsHelper = (function () {
    function ExpressionsHelper(filterExpressionHelper, searchExpressionHelper) {
        var expressionHelperUtilities = new ExpressionHelperUtilities_1["default"]();
        this.filterExpressionHelper = filterExpressionHelper || new FilterExpressionHelper_1["default"](expressionHelperUtilities);
        this.searchExpressionHelper = searchExpressionHelper || new SearchExpressionsHelper_1["default"](expressionHelperUtilities);
    }
    ExpressionsHelper.prototype.getFilterExpression = function (options) {
        var expression = this.filterExpressionHelper.getContextFilterExpressions(options);
        return this.filterExpressionHelper.appendExternalContentToExpression(expression, options);
    };
    ExpressionsHelper.prototype.getSearchExpression = function (options) {
        var expressions = [
            this.searchExpressionHelper.getSourcesAndCollectionsExpression(options, options, options),
            this.searchExpressionHelper.getSearchFilterExpression(options, options),
            this.searchExpressionHelper.getSearchBoostExpression(options)
        ];
        return expressions.filter(function (expression) { return expression !== ""; }).join(" ");
    };
    ;
    return ExpressionsHelper;
}());
exports.__esModule = true;
exports["default"] = ExpressionsHelper;



//////////////////
// WEBPACK FOOTER
// ./Base/Rules/ExpressionsHelper.ts
// module id = 8
// module chunks = 0